import React from 'react';
import { dispatchSync, useReframe } from 'nike-re-framejs';

import i18n from '@i18n';
import InfiniteScroll from '@/responsive/components/InfiniteScroll/InfiniteScroll';
import BetbookComment from '@/betbook/components/betbook-comment/BetbookComment';

import './BetbookPostComments.less';
import EmptyCommentIcon from 'nike-ui/src/icons/svg/empty-comment-icon-sv.svg';
import { loadMorePostComments } from '@/betbook/handlers';
import { comments$, hasMoreComments$ } from '@/betbook/subs';

function BetbookPostComments({ subjectId, subjectType, topicStatus }) {
    const { subscribe } = useReframe();
    const hasMore = subscribe(hasMoreComments$);

    const comments = subscribe(comments$);
    if (!comments) {
        return (
            <div className="betbook-post-comments">
                <div className="comments-loader" key="loader">
                    <div className="mini-preloader infinite-loader" />
                </div>
            </div>
        );
    }

    const commentsIds = comments.allIds;
    if (!commentsIds) {
        return null;
    }
    function loadMore() {
        dispatchSync(loadMorePostComments(subjectType, subjectId));
    }

    return (
        <InfiniteScroll
            className="betbook-post-comments"
            hasMore={hasMore}
            loadMore={loadMore}
            loader={
                <div className="comments-loader" key="loader">
                    <div className="mini-preloader infinite-loader" />
                </div>
            }
            threshold={0}
            initialLoad={false}
        >
            {commentsIds.length === 0 ? (
                <BetbookCommentsEmpty topicStatus={topicStatus} />
            ) : (
                commentsIds.map(commentId => (
                    <BetbookComment
                        key={commentId}
                        commentId={commentId}
                        subjectId={subjectId}
                        subjectType={subjectType}
                        topicStatus={topicStatus}
                    />
                ))
            )}
        </InfiniteScroll>
    );
}

function BetbookCommentsEmpty({ topicStatus }) {
    return (
        <div className="betbook-post-comments-empty">
            <EmptyCommentIcon />
            {topicStatus === 'ENABLED' && (
                <>
                    <div className="row-one">{i18n('betbook.comments.empty.rowOne')}</div>
                    <div className="row-two">{i18n('betbook.comments.empty.rowTwo')}</div>
                </>
            )}
        </div>
    );
}

export default BetbookPostComments;
